import { makeRequest, CommonRequestOptions } from '../makeRequest';

export async function deleteQuizzes(
   quizids: number[],
   { ...common }: CommonRequestOptions
): Promise<void> {
   return makeRequest('post', '/quizzes/delete', {
      ...common,
      body: {
         quizids,
      },
   });
}
